import comingAppImg from "@images/coming-app.png"
import comingAppGzImg from "@imagesgz/coming-app.png"
import comingPcImg from "@images/coming-pc.png"
import comingPcGzImg from "@imagesgz/coming-pc.png"
import { ThemeContext } from "@src/context"
import React, { useContext } from "react"
import ResponsiveImage from "./image"

const ResponsiveComing = () => {
  const theme = useContext(ThemeContext)
  return (
    <ResponsiveImage
      pc={theme === "gz" ? comingPcGzImg : comingPcImg}
      mobile={theme === "gz" ? comingAppGzImg : comingAppImg}
    />
  )
}

export default ResponsiveComing
